import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Input,
  Button,
  List,
  Spin,
  Card,
  Switch,
  Flex,
  Checkbox,
  Slider,
} from "antd";
import {
  useUpdateChecklistMutation,
  useFetchChecklistQuery,
} from "../opencheck/checklists.service";
import { EditOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./style.css";
import TextEditor from "../../components/TextEditor";

// ✅ 1. Component name change kiya
const MonthlycheckUpdate = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const navigate = useNavigate();
  const { id } = useParams();

  const [newChecklist, setNewChecklist] = useState("");
  const [isInput, setIsInput] = useState(false);
  const [record, setRecord] = useState("");
  const [isSection, setIsSection] = useState(false);
  const [isTempSlider, setIsTempSlider] = useState(false);
  const [tempSlider, setTempSlider] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  const [checkContent, setCheckContent] = useState();
  
  const {
    data: checklist = {},
    isFetching,
    isSuccess,
  } = useFetchChecklistQuery(id, { refetchOnMountOrArgChange: true });
  
  const [updateChecklist, { isLoading: isEditLoading }] =
    useUpdateChecklistMutation();

  useEffect(() => {
    if (isSuccess) {
      setNewChecklist(checklist[`title_${language}`] || checklist[`title_en`]);
      setIsInput(checklist.isInput);
      setIsCompleted(checklist.status === "completed");
      setIsTempSlider(checklist.isTempSlider);
      setTempSlider(checklist.tempSlider || 0);
      
      // ✅ Record type set karo
      if (checklist.isDateRecord) setRecord("recordTD");
      if (checklist.isTemperature) setRecord("recordTemp");
      
      setCheckContent(
        checklist[`content_${language}`] || checklist[`content_en`]
      );
      setIsSection(checklist.isSection);
    }
  }, [checklist, language, isSuccess]);

  const handleUpdate = async () => {
    try {
      // ✅ Validation add kiya
      if (!newChecklist) {
        // Section ke liye title empty ho sakta hai?
        if (!isSection) {
          // Agar section nahi hai to title required hai
          // Aap yahan toast error show kar sakte hain
        }
      }

      const updateData = {
        isDateRecord: record === "recordTD",
        isTemperature: record === "recordTemp",
        isInput,
        isSection,
        isTempSlider,
        tempSlider,
        title: newChecklist,
        status: isCompleted ? "completed" : "pending",
      };

      // ✅ Content sirf tab bhejo jab input ho
      if (isInput && checkContent && checkContent !== "") {
        updateData.content = checkContent;
      }

      await updateChecklist({
        id,
        data: updateData,
      });
      
      // ✅ Success ke baad navigate karo
      navigate("/monthlychecks");
      
    } catch (err) {
      console.log("Failed to update checklist");
      // Yahan toast error show kar sakte hain
    }
  };

  return (
    <Spin spinning={isFetching}>
      <Card
        // ✅ 2. Title change kiya
        title={t("MONTHLY CHECKLIST EDIT")}
        style={{ fontSize: "20px" }}
        bordered={false}
        className="opencheck-create-page"
        extra={
          <Flex justify="center">
            {/* ✅ 3. Back button path change kiya */}
            <Button type="default" onClick={() => navigate("/monthlychecks")}>
              {t("BACK")}
            </Button>
          </Flex>
        }
      >
        <div className="opencheck-create-page-container">
          <TextEditor
            newChecklist={newChecklist}
            setNewChecklist={setNewChecklist}
          />
          
          <div className="opencheck-create-page-container-switch">
            <h4>{t("ADD TEXTBOX")}</h4>
            <Switch
              value={isInput}
              onChange={(e) => {
                if (e) {
                  setIsSection(false);
                  setRecord(""); // Textbox on hai to record off karo
                  setIsTempSlider(false);
                }
                setIsInput(e);
              }}
              disabled={isSection} // Section hai to disable
            />
          </div>
          
          <div className="opencheck-create-page-container-switch">
            <h4>{t("RECORD TEMPERATURES")}</h4>
            <Switch
              value={record === "recordTemp"}
              onChange={(e) => {
                if (e) {
                  setIsSection(false);
                  setIsInput(false);
                  setIsTempSlider(false);
                }
                setRecord(e ? "recordTemp" : "");
              }}
              disabled={isSection}
            />
          </div>
          
          <div className="opencheck-create-page-container-switch">
            <h4>{t("RECORD TIME & DATE")}</h4>
            <Switch
              value={record === "recordTD"}
              onChange={(e) => {
                if (e) {
                  setIsSection(false);
                  setIsInput(false);
                  setIsTempSlider(false);
                }
                setRecord(e ? "recordTD" : "");
              }}
              disabled={isSection}
            />
          </div>
          
          <div className="opencheck-create-page-container-switch">
            <h4>{t("ADD TEMPERATURE SLIDER")}</h4>
            <Switch
              value={isTempSlider}
              onChange={(e) => {
                if (e) {
                  setIsSection(false);
                  setIsInput(false);
                  setRecord("");
                }
                setIsTempSlider(e);
              }}
              disabled={isSection}
            />
          </div>
          
          <div className="opencheck-create-page-container-switch">
            <h4>{t("SECTION")}</h4>
            <Switch
              value={isSection}
              onChange={(e) => {
                if (e) {
                  // ✅ Section mode mein sab off karo
                  setIsInput(false);
                  setRecord("");
                  setIsTempSlider(false);
                  setTempSlider(0);
                }
                setIsSection(e);
              }}
            />
          </div>
          
          <div className="opencheck-create-page-container-button">
            <Button
              color="green"
              variant="solid"
              icon={<EditOutlined />}
              size="small"
              onClick={handleUpdate}
              loading={isEditLoading}
            >
              {t("Update")}
            </Button>
          </div>
        </div>

        <List
          className="opencheck-create-page-insight"
          itemLayout="horizontal"
          dataSource={[
            {
              isSection: isSection,
              title: isSection ? "" : newChecklist,
              description: isSection ? (
                <div
                  className="compliance-checklist-content"
                  dangerouslySetInnerHTML={{
                    __html: newChecklist,
                  }}
                ></div>
              ) : (
                <div className="opening-check-add-task">
                  {isInput && (
                    <div style={{ padding: "5px 15px" }}>
                      <Input
                        style={{ background: "transparent" }}
                        value={checkContent}
                        onChange={(e) => setCheckContent(e.target.value)}
                        placeholder={t("Enter content here...")}
                      />
                    </div>
                  )}
                  
                  {isTempSlider && (
                    <>
                      <div
                        style={{
                          fontSize: "1.5rem",
                          textAlign: "center",
                          marginTop: 10,
                          fontWeight: "bold",
                        }}
                      >
                        {tempSlider.toFixed(1)}°C
                      </div>
                      <Slider
                        min={-30}
                        max={120}
                        step={0.1}
                        onChange={(temp) => setTempSlider(temp)}
                        value={tempSlider}
                      />
                    </>
                  )}
                  
                  {record === "recordTD" && (
                    <div style={{ padding: "10px", fontStyle: "italic" }}>
                      * {t("RECORD TIME AND DATE AUTOMATICALLY")} *
                    </div>
                  )}
                  
                  {record === "recordTemp" && (
                    <div style={{ padding: "10px", fontStyle: "italic" }}>
                      * {t("RECORD FRIDGE TEMPERATURES AUTOMATICALLY")} *
                    </div>
                  )}
                </div>
              ),
            },
          ]}
          renderItem={(item) => (
            <List.Item
              className={
                item.title === "" ? "background-section" : "background-task"
              }
              actions={[
                <Checkbox
                  checked={isCompleted}
                  onChange={(e) => setIsCompleted(e.target.checked)}
                >
                  {t("Completed")}
                </Checkbox>,
              ]}
            >
              <List.Item.Meta
                title={
                  item.title !== "" && (
                    <div
                      className="compliance-checklist-content"
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                  )
                }
                description={item.description}
              />
            </List.Item>
          )}
        />
      </Card>
    </Spin>
  );
};

// ✅ 4. Export name change kiya
export default MonthlycheckUpdate;